// DO NOT REMOVE THIS LINE, TESTS RELY IN THE ORDER OF THE gridDimensions OUTPUT
/* eslint-disable sort-keys-fix/sort-keys-fix */
import { ViewportType } from '../context/ui/ViewportContext/ViewportType';

export interface GridDimension {
  minScreenWidth: number;
  maxScreenWidth: number;
  maxContainerWidth?: number;
  margin: number;
  gutter: number;
}

const SCREEN_WIDTH_XL_MIN = 1201;
const SCREEN_WIDTH_LG_MAX = SCREEN_WIDTH_XL_MIN - 1;
const SCREEN_WIDTH_LG_MIN = 961;
export const SCREEN_WIDTH_MD_MAX = SCREEN_WIDTH_LG_MIN - 1;
const SCREEN_WIDTH_MD_MIN = 641;
const SCREEN_WIDTH_SM_MAX = SCREEN_WIDTH_MD_MIN - 1;

export const gridDimensions: { [key in ViewportType]: GridDimension } = {
  sm: {
    minScreenWidth: 0,
    maxScreenWidth: SCREEN_WIDTH_SM_MAX,
    maxContainerWidth: undefined,
    margin: 16,
    gutter: 16,
  },
  md: {
    minScreenWidth: SCREEN_WIDTH_MD_MIN,
    maxScreenWidth: SCREEN_WIDTH_MD_MAX,
    maxContainerWidth: 608,
    margin: 32,
    gutter: 16,
  },
  lg: {
    minScreenWidth: SCREEN_WIDTH_LG_MIN,
    maxScreenWidth: SCREEN_WIDTH_LG_MAX,
    maxContainerWidth: undefined,
    margin: 32,
    gutter: 24,
  },
  xl: {
    minScreenWidth: SCREEN_WIDTH_XL_MIN,
    maxScreenWidth: Number.POSITIVE_INFINITY,
    maxContainerWidth: 1312,
    margin: 64,
    gutter: 32,
  },
};
